import { baseApi } from 'shared/api/baseApi'
import { DISCIPLINE_TAG } from 'shared/api/tags'
import type { DisciplineItem, DisciplineRequestBody } from '../model/type'

export const disciplinesApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        getDisciplines: build.query<DataWithMeta<DisciplineItem>, Params>({
            query: (params) => ({
                url: `disciplines?${params.params}`,
                method: 'GET',
            }),
            providesTags: [DISCIPLINE_TAG],
        }),
        createDiscipline: build.mutation<
            ApiResponse<DisciplineItem>,
            {
                sportId: string
                body: Omit<DisciplineRequestBody, 'disciplineId' | 'sportId'>
            }
        >({
            query: ({ sportId, body }) => ({
                url: `sports/${sportId}/disciplines`,
                method: 'POST',
                body: body,
            }),
            invalidatesTags: [DISCIPLINE_TAG],
        }),
        updateDiscipline: build.mutation<
            ApiResponse<DisciplineItem>,
            {
                sportId: string
                disciplineId: string
                body: Omit<DisciplineRequestBody, 'disciplineId' | 'sportId'>
            }
        >({
            query: ({ sportId, disciplineId, body }) => ({
                url: `sports/${sportId}/disciplines/${disciplineId}`,
                method: 'PATCH',
                body: body,
            }),
            invalidatesTags: [DISCIPLINE_TAG],
        }),
    }),
})

export const {
    useGetDisciplinesQuery,
    useCreateDisciplineMutation,
    useUpdateDisciplineMutation,
} = disciplinesApi
